// Shared hardening for <input type="number"> fields used in payroll/payslip flows.
//
// Browsers natively accept "e", "E", "+", "-" inside number inputs (for scientific
// notation), and the scroll wheel silently mutates the value when the input has
// focus. Both are misleading on a payslip form - money values are always non-
// negative finite decimals. Spread `numericInputProps` onto the input to:
//   • block e / E / + / − on keydown
//   • strip those characters from any pasted text
//   • prevent wheel scroll from changing the value
//
//   <input type="number" {...numericInputProps} … />
//
// Decimals (`.`) and digits remain typeable; min/step/max still work as usual.

export const blockInvalidNumericKeys = (e) => {
    if (["e", "E", "+", "-"].includes(e.key)) {
        e.preventDefault();
    }
};

export const sanitizeNumericPaste = (e) => {
    const text = (e.clipboardData || window.clipboardData)?.getData("text") || "";
    if (/[eE+\-]/.test(text)) {
        e.preventDefault();
    }
};

export const blockNumericWheel = (e) => {
    // Blur removes focus so the wheel scrolls the page instead of the value
    e.target.blur();
};

// On blur, collapse redundant zeros to the clean numeric value: "000" -> "0",
// "0.00" -> "0", "05" -> "5", "1500.00" -> "1500". Uses the native value setter
// + a synthetic input event so React's controlled onChange picks up the change.
export const normalizeNumericOnBlur = (e) => {
    const el = e.target;
    const v = el.value;
    if (v === "" || v == null) return;
    const n = parseFloat(v);
    const clean = Number.isNaN(n) ? "" : String(n);
    if (clean !== v) {
        const setter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value")?.set;
        if (setter) {
            setter.call(el, clean);
            el.dispatchEvent(new Event("input", { bubbles: true }));
        }
    }
};

export const numericInputProps = {
    onKeyDown: blockInvalidNumericKeys,
    onPaste: sanitizeNumericPaste,
    onWheel: blockNumericWheel,
    onBlur: normalizeNumericOnBlur,
};
